import moment from "jalali-moment";

export const jmoment = moment.updateLocale("fa", {
  weekdaysMin: [],
});

export const getDateAsFileName = () => {
  return moment().local().locale("fa").format("YYYY_MM_DD_HH_mm");
};

export const dateToJalali = (d?: { date?: string; format?: string }) => {
  return moment(d?.date || undefined)
    .locale("fa")
    .format(d?.format || "YYYY/MM/DD");
};
